<template>
  <CohortFilterLayout title="(All)" :options="options" middle :selectedText="selectedText" @clear="$emit('input', [])">
    <div class="hvh-flex column">
      <v-text-field class="mb-3" v-model="searchText" label="Search" prepend-inner-icon="mdi-magnify" :hideDetails="true" outline />
      <div class="options-box">
        <CohortTreeFilterGroup :group="item" :value="computedValue" itemLabel="label" itemValue="id" @input="$emit('input', $event)" v-for="(item, ind) in items" :key="ind" />
      </div>
    </div>
  </CohortFilterLayout>
</template>

<script>
import CohortTreeFilterGroup from './CohortTreeFilterGroup.vue';
import CohortFilterLayout from './CohortFilterLayout.vue';
import { getDemographics, regionalizeStates } from '../../../../libraries/cohorts';
export default {
  components: { CohortFilterLayout, CohortTreeFilterGroup },
  props: ['value'],
  data() {
    var demographics = getDemographics();
    var states = demographics.states
      .reduce((acc, f) => { acc[f.value] = f.text; return acc; }, {});
    return {
      options: null,
      showOptions: true,
      searchText: null,
      items: ['Mid West', 'North East', 'South East', 'South West', 'West']
        .map(region => ({
          id: region,
          label: region,
          children: demographics[region]
            .map(f => ({ id: f, label: states[f] }))
        })),
    };
  },
  computed: {
    selectedText() {
      if (!(this.value || []).any() || this.value.length === this.items.sum(f => f.children.length)) return '';
      var regionalized = regionalizeStates(this.value);
      var plusText = regionalized.length > 1 ? ` +${regionalized.tail().sum(f => f.states.length)}` : '';
      return `${regionalized.first().label}${plusText}`;
    },
    computedValue() {
      return !this.value?.any() ? this.items.flatMap(f => f.children.map(g => g.id)) : this.value;
    },
  },
  methods: {
    stateSelected(event) {
      var states = event.map(f => this.items.find(g => g.id === f) || f)
        .flatMap(f => f.children || [f])
        .map(f => f.id || f);

      this.$emit('input', states);
    },
  },
}
</script>

<style lang="scss" scoped>
.options-box {
  overflow: auto;
  max-height: 300px;
  // padding: 20px 16px 4px;
}
</style>